import React, { Fragment } from 'react';

export class PrivacyPolicy extends React.Component {
	render() {
		return (
			<Fragment>
				<div className="container document">
					<section className="hero is-light header">
						<div className="hero-body">
							<div className="container has-text-centered">
								<img alt="logo" src="/legalIcon.svg" />
								<h1 className="title has-text-light add-lg-margin-top">
									Privacy Policy
								</h1>
								<label className="subtitle is-6 has-text-light">
									Updated 24 August 2020
								</label>
							</div>
						</div>
					</section>
					<div className="section">
						<div className="section content">
							<span className="title is-5"> Lorem Ipsum</span>
							<br />
							<br />
							Lorem Ipsum is simply dummy text of the printing and typesetting
							industry. Lorem Ipsum has been the industry's standard dummy text
							ever since the 1500s, when an unknown printer took a galley of
							type and scrambled it to make a type specimen book. It has
							survived not only five centuries, but also the leap into
							electronic typesetting, remaining essentially unchanged. It was
							popularised in the 1960s with the release of Letraset sheets
							containing Lorem Ipsum passages, and more recently with desktop
							publishing software like Aldus PageMaker including versions of
							Lorem Ipsum.
						</div>
					</div>
				</div>
			</Fragment>
		);
	}
}
